import Cookies              from 'js-cookie';
import helperUtilities      from 'shared/mixins/helper-utilities';

/**
 * @module
 * 
 */
 
const selector = '[data-js-questions]';
const nyQuestions = function(el, app) {
    
    const utilities = helperUtilities(app);

    const cookiePrefix = app.cookiePrefix;
    let   acceptingClicks = false;
    const $document = $(document);
    const $el = $(el);
    const $items = $el.find('[data-js-questions-outer]');
    const $radios = $el.find('[data-js-questions-input]');
    const $qs = $el.find('[data-js-questions-question]');
    const $answered = $el.find('.Ge-Ny-Questions-Outer--answered');
    const $close = $el.find('[data-js-questions-close]');
    
    const init = function() {
        registerEvents();
        setupTree();
    };
    
    const setupTree = function() {
        $.each($radios,function setupTreeEach (index,el) {
            const $el = $(el);
            const inputName = $el.attr('name');
            const inputValue = $el.attr('value');
            const cookieName = utilities.getAppName() + 'Q-' + inputName;
            const cookieValue = Cookies.get(cookieName,{ path: '/' });
            if (cookieValue === inputValue) {
                $el.prop('checked',true);
                $el.trigger('questionUpdate',[true]);
            }
        });
        setTimeout(function(){
            $el.addClass('Ge-Ny-Questions--animate');
        },500);
        acceptingClicks = true;
        // ARIA
        $items.not(':first-child').attr('aria-hidden', 'true');
        $qs.attr('tabindex','0');
        $radios.attr('tabindex','0');
        $el.addClass('Ge-Ny-Questions--ready');
    };
    
    const registerEvents = function() {
        $radios.on('change',answerQuestion);
        $radios.on('questionUpdate',answerQuestion);
        $radios.on('questionAnswered',answerQuestion); // custom event when we want to trigger the same result as triggering "change", but not set off any other events in other scripts (eg, recommendation updates)
        $radios.on('click',answerClick);
        $document.on('click','[data-js-questions-close]',closeQuestion);
        $qs.on('click',tabToFirstOption);
        $el.on('click keyup','.Ge-Ny-Questions-Outer--answered:not(.Ge-Ny-Questions-Outer--open)',reAnswerQuestion);
    };
    
    const tabToFirstOption = function(ev) {
        ev.preventDefault();
        $(this).closest('[data-js-questions-outer]').find('[data-js-questions-input]').first().focus();
    };
    
    const answerQuestion = function(ev,bypassAcceptingClicks) {
        if (!bypassAcceptingClicks && !acceptingClicks) {
            return;
        }
        const $treeInput = $(this);
        const inputName = $treeInput.attr('name');
        const inputValue = $treeInput.attr('value');
        const $treeOption = $treeInput.closest('[data-js-questions-option]');
        const $treeQThis = $treeInput.closest('[data-js-questions-outer]');
        const $treeQNext = $treeQThis.next('[data-js-questions-outer]').not('.Ge-Ny-Questions-Outer--answered');
        // reset old classes
        $treeQThis.removeClass('Ge-Ny-Questions-Outer--open');
        $treeOption.siblings('[data-js-questions-option]').removeClass('Ge-Ny-Questions-A-Option--checked');
        // add new classes
        $treeOption.addClass('Ge-Ny-Questions-A-Option--checked');
        $treeQThis.addClass('Ge-Ny-Questions-Outer--answered');
        if ($treeQNext.length) {
            $treeQNext.addClass('Ge-Ny-Questions-Outer--open');
        }
        // ARIA
        $treeQThis.find('[data-js-questions-option]').attr('aria-hidden', 'true');
        $treeQThis.find('[data-js-questions-input]').attr('aria-hidden', 'true');
        $treeQNext.attr('aria-hidden', 'false');
        $treeQNext.find('[data-js-questions-question]').focus();
        // cookie
        const cookieName = utilities.getAppName() + 'Q-' + inputName;
        Cookies.set(cookieName, inputValue, { expires: app.cookieLong });
        // accept clicks again
        acceptingClicks = false;
        setTimeout(function() {
            acceptingClicks = true;
        },300);
        
        // ga
        if (ev && ( ev.type === 'change' || ev.type === 'questionAnswered' ) ) {
            const questionText = $treeInput.closest('[data-js-questions-inner]').find('[data-js-questions-question]').text();
            const answerText = $treeInput.next('[data-js-questions-answer]').text();
            app.trigger('beacon','hjälp-mig-question-answer,' + questionText + ': ' + answerText);
        }
    };
    
    const answerClick = function (ev) {
        if ($(this).prop('checked')) {
            $(this).trigger('questionAnswered');
        }
    };
    
    const closeQuestion = function (ev) {
        ev.stopPropagation();
        const $outer = $(this).closest('[data-js-questions-outer]');
        const $input = $outer.find('[data-js-questions-input]:checked');
        $input.trigger('questionUpdate');
    };
    
    const reAnswerQuestion = function(ev) {
        if (!acceptingClicks) {
            return;
        }
        ev.preventDefault();
        const $el = $(this);
        $items.removeClass('Ge-Ny-Questions-Outer--open');
        $el.addClass('Ge-Ny-Questions-Outer--open');
        // ARIA
        $el.find('[data-js-questions-option]').attr('aria-hidden', 'false');
        $el.find('[data-js-questions-input]').attr('aria-hidden', 'false');
        
        // ga
        const questionText = $el.find('[data-js-questions-question]').text();
        app.trigger('beacon','hjälp-mig-question-reopen,' + questionText);
    };

    return {
        init: init()
    };
};

nyQuestions.selector = selector;

export default nyQuestions;
